import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import type {IJSONProvider} from "data/providers/json/json.provider";
import {Bindings} from "data/constants/bindings";
import {GameStatus} from "data/enums";

export interface IGame {
	id: number;
	feedId: string;
	homeSquadId: number;
	awaySquadId: number;
	date: string;
	status: GameStatus;
	currentInning: number | null;
}

export interface IGamesStore {
	get getIsLoading(): boolean;
	get list(): IGame[];
	getGameById(playerId: number): IGame | undefined;
	fetchGames(): Promise<void>;
}

@injectable()
export class GamesStore implements IGamesStore {
	@observable private _isLoading: boolean = false;

	constructor(@inject(Bindings.JSONProvider) private _jsonProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	@observable private _list: IGame[] = [];

	get list() {
		return this._list;
	}

	get getIsLoading(): boolean {
		return this._isLoading;
	}

	getGameById(id: number): IGame | undefined {
		return this._list.find((game) => game.id === id);
	}

	@action
	async fetchGames() {
		const {data} = await this._jsonProvider.games();

		runInAction(() => {
			this._list = data;
		});
	}
}
